import React, { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@ann/web-components";
import useStore from "../hooks/useStore";
import { runSignOut } from "../utils/authLogout";

const ForbiddenPage = () => {
  const { logout } = useAuth0();
  const { authStore, workspaceStore } = useStore();

  const handleLogout = useCallback(() => {
    runSignOut(logout, { authStore, workspaceStore });
  }, [authStore, workspaceStore, logout]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: 24,
        textAlign: "center",
      }}
    >
      <h1 style={{ marginBottom: 8, fontSize: 24 }}>Access Denied</h1>
      <p style={{ marginBottom: 24, color: "#666" }}>
        You do not have permission to access this page.
      </p>
      <Button
        type="primary"
        label="Log out"
        onClick={handleLogout}
        style={{ maxWidth: 200 }}
      />
    </div>
  );
};

export default ForbiddenPage;
